<template>
  <div>
    <PageAllow controller="PositionCurrents" action="index" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <!-- 仓库中心 -->
              <SearcherStock
                v-model="stockSelected"
                :stock-types="[0]"
                unclearable
                :wmsSetting="[1]"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 当前库位导出 -->
              <v-btn
                v-if="
                  $permission.permissionAllow(
                    'PositionCurrents',
                    'export'
                  )
                "
                small
                color="print"
                dark
                class="ms-1"
                @click="exports()"
              >
                <v-icon x-small class="pe-1">fa-file-export</v-icon>
                {{ $t("CurrentPosition.Export.position_currents_export") }}
              </v-btn>
              <v-btn
                v-if="$permission.permissionAllow('positionCurrents', 'export')"
                small
                color="print"
                dark
                class="ms-1"
                href=""
              >
                <v-icon x-small class="pe-1">fa-file-export</v-icon>
                {{ $t("CurrentPosition.Export.stock_position_material_out") }}
              </v-btn>
              <!-- <v-btn small color="print" dark class="ms-1" href="">
                <v-icon x-small class="pe-1">fa-file-export</v-icon>
                {{ $t("CurrentPosition.Export.stock_position_in") }}
              </v-btn> -->
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <!-- 库区 -->
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="stockSelected && stockSelected.stock_area"
                >
                  <SearcherStockArea
                    v-model="areasSelected"
                    :stockId="stockSelected ? stockSelected.id : 0"
                  />
                </v-col>
                <!-- 库位标签 -->
                <v-col cols="12" sm="6" md="4">
                  <StockPositionLabel
                    v-model="positionLabelslSelected"
                    :stockId="stockSelected ? stockSelected.id : 0"
                  />
                </v-col>
                <!-- 库位 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStockPosition
                    v-model="positionSelected"
                    :stockId="stockSelected ? stockSelected.id : 0"
                    :stockAreaSetting="
                      stockSelected && stockSelected.stock_area ? true : false
                    "
                    :stockAreaId="areasSelected ? areasSelected.id : -1"
                  />
                </v-col>
                <!-- 商品分类 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherMaterialCategoriesWithDescendants
                    v-model="materialCategoriesSelected"
                  />
                </v-col>
                <!-- 商品 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherMaterials
                    v-model="materialSelected"
                    :material-categories="materialCategoriesSelected"
                  />
                </v-col>
                <!-- 是否显示零售商品库位 是/否 -->
                <SearcherStatus
                  :items="$consts.statusFlgs"
                  :label="$t('CurrentPosition.status.ObjectName')"
                  v-model="options.status"
                />
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="PositionCurrentItems"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1 sticky-table"
            id="sticky-table"
            :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
            fixed-header
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>

            <template v-slot:item.material_name="{ item, index }">
              <span
                class="text-no-wrap"
                :v-resize="!index ? $stickTableResizer() : null"
              >
                {{
                  settings
                    ? $t(
                        settings
                          ? settings.material_name_display_type == 4
                            ? "Material.nameWithCodeAndStandard"
                            : settings.material_name_display_type == 3
                            ? "Material.materialNameWithCodeAndStandard"
                            : settings.material_name_display_type == 2
                            ? "Material.materialNameWithCode"
                            : "Material.materialName"
                          : "Material.materialName",
                        [
                          item.material_code,
                          item.material_name,
                          item.standard_name,
                        ]
                      )
                    : item.material_name
                }}
              </span>
            </template>
            <template v-slot:item.stock_area="{ item }">
              <span class="text-no-wrap">
                {{ item.stock_area }}
              </span>
            </template>
            <template v-slot:item.stock_roadway_code="{ item }">
              <span class="text-no-wrap">
                {{ item.stock_roadway_code }}
              </span>
            </template>
            <template v-slot:item.position_description="{ item }">
              <span class="text-no-wrap">
                {{ item.position_description }}
              </span>
            </template>
            <template v-slot:item.position_code="{ item }">
              <span class="text-no-wrap">
                {{ item.position_code }}
              </span>
            </template>
            <template v-slot:item.positon_label_name="{ item }">
              <span class="text-no-wrap">
                {{ item.positon_label_name }}
              </span>
            </template>
            <!-- 格式化数字 -->
            <template v-slot:item.currentNumTotal="{ item }">
              {{ item.currentNumTotal | formatTwoDot }}
            </template>
            <template v-slot:item.actions="{ item }">
              <!-- 流水明细 -->
              <v-tooltip
                top
                v-if="
                  $permission.permissionAllow('PositionActivities', 'index')
                "
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    v-bind="attrs"
                    v-on="on"
                    :dark="detailMode"
                    color="info"
                    class="px-2 me-2"
                    :href="
                      '/#/current-position/detail/' +
                      item.stock_position_id +
                      '?' +
                      'stock_id=' +
                      options.stock_id +
                      '&' +
                      'stock_area_id=' +
                      item.stock_area_id +
                      '&' +
                      'material_id=' +
                      item.material_id
                    "
                  >
                    <v-icon x-small class="pe-1">fa-align-left</v-icon>
                    {{ $t("CurrentPosition.edit.details") }}
                  </v-btn>
                </template>
                <span>{{
                  $t("CRUD.viewInfo", [$t("CurrentPosition.edit.details")])
                }}</span>
              </v-tooltip>
              <!-- 批次明细 -->
              <v-tooltip
                top
                v-if="$permission.permissionAllow('StockDetails', 'index') && options.status.length == 1 && options.status.find((s) => s == 1)"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    v-bind="attrs"
                    v-on="on"
                    :dark="detailMode"
                    color="info"
                    class="px-2 me-2"
                    :href="
                      '/#/current-position/stock-detail?' +
                      'stock_position_id=' +
                      item.stock_position_id +
                      '&' +
                      'stock_id=' +
                      options.stock_id +
                      '&' +
                      'material_id=' +
                      item.material_id
                    "
                  >
                    <v-icon x-small class="pe-1">fa-align-left</v-icon>
                    {{ $t("CurrentPosition.edit.stockDetail") }}
                  </v-btn>
                </template>
                <span>{{ $t("CRUD.viewInfo", [$t("CurrentPosition.edit.stockDetail")]) }}</span>
              </v-tooltip>
              <!-- 库位移动 -->
              <v-tooltip
                top
                v-if="
                  false && $permission.permissionAllow('PositionMoves', 'move')
                "
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    v-bind="attrs"
                    v-on="on"
                    :dark="detailMode"
                    color="info"
                    class="px-2 me-2"
                    :href="'/#/position-material-move/' + item.material_id"
                  >
                    <v-icon x-small class="pe-1">fa-align-left</v-icon>
                    {{ $t("CurrentPosition.edit.stock_position_move") }}
                  </v-btn>
                </template>
                <span>{{
                  $t("CRUD.viewInfo", [
                    $t("CurrentPosition.edit.stock_position_move"),
                  ])
                }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherStock from "@/components/plugins/SearcherStock";
import PositionCurrents from "@/api/position_currents";
import SearcherMaterialCategoriesWithDescendants from "@/components/plugins/SearcherMaterialCategoriesWithDescendants";
import SearcherMaterials from "@/components/plugins/SearcherMaterials";
import SearcherStockPosition from "@/components/plugins/SearcherStockPosition";
import StockPositionLabel from "@/components/plugins/SearcherStockPositionLabels";
import SearcherStockArea from "@/components/plugins/SearcherStockArea";
import SearcherStatus from "@/components/plugins/SearcherStatus";

const defaultOptions = {
  status: [1],
  category_codes: [],
  material_ids: [],
  stock_id: "",
  stock_area_id: null,
  position_label_id: null,
  stock_position_id: null,
};

export default {
  data: () => ({
    position_currents: [],
    stockSelected: null,
    areasSelected: null,
    positionLabelslSelected: null,
    positionSelected: null,
    materialCategoriesSelected: [],
    materialSelected: [],
    paging: {},
    options: JSON.parse(
      sessionStorage.getItem("position-currents-options")
        ? sessionStorage.getItem("position-currents-options")
        : JSON.stringify(defaultOptions)
    ),
    loading: false,
  }),
  components: {
    Breadcrumbs,
    SearcherStock,
    PageAllow,
    SearcherMaterialCategoriesWithDescendants,
    SearcherMaterials,
    StockPositionLabel,
    SearcherStockPosition,
    SearcherStockArea,
    SearcherStatus,
  },
  props: {
    detailMode: Boolean,
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.stockManagement"),
        disabled: false,
        href: "/stocks",
      },
      {
        text: i18n.t("Nav.currentPosition"),
        disabled: true,
        href: "/current-position",
      },
    ],
    headers: () => [
      {
        text: i18n.t("CurrentPosition.Fields.material"),
        align: "start",
        sortable: false,
        value: "material_name",
      },
      {
        text: i18n.t("CurrentPosition.Fields.areas"),
        align: "start",
        sortable: false,
        value: "stock_area",
      },
      {
        text: i18n.t("CurrentPosition.Fields.roadway_code"),
        align: "start",
        sortable: false,
        value: "stock_roadway_code",
      },
      {
        text: i18n.t("CurrentPosition.Fields.stock_position_name"),
        align: "start",
        sortable: false,
        value: "position_description",
      },
      {
        text: i18n.t("CurrentPosition.Fields.position_code"),
        align: "start",
        sortable: false,
        value: "position_code",
      },
      {
        text: i18n.t("CurrentPosition.Fields.stock_position_labels"),
        align: "start",
        sortable: false,
        value: "positon_label_name",
      },
      {
        text: i18n.t("CurrentPosition.Fields.num"),
        align: "end",
        sortable: false,
        value: "currentNumTotal",
      },
      {
        text: i18n.t("CurrentPosition.Fields.unit"),
        align: "end",
        sortable: false,
        value: "unit",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],

    PositionCurrentItems() {
      return this.position_currents.map((position) => {
        var position_description = i18n.t(
          "MovePositionOrder.DetailFields.position",
          [position.position_code, position.position_name]
        );
        if (this.stockSelected && this.stockSelected.position_name_display) {
          if (this.stockSelected.position_name_display.indexOf(2) > -1) {
            position_description = position.position_name;
          }
          if (
            this.stockSelected.position_name_display.indexOf(4) > -1 &&
            position.stock_roadway_code
          ) {
            position_description =
              position.stock_roadway_code + " - " + position_description;
          }
          if (
            this.stockSelected.position_name_display.indexOf(3) > -1 &&
            position.stock_area
          ) {
            position_description =
              position.stock_area + " - " + position_description;
          }
        }

        return Object.assign({}, position, { position_description });
      });
    },
    ...mapState(["settings", "stickTableCols"]),
  },

  mounted() {
    this.$commonUtils
      .loadOptions("position-currents", [
        "stockSelected",
        "areasSelected",
        "positionLabelslSelected",
        "positionSelected",
        "materialCategoriesSelected",
        "materialSelected",
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();

          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "stockSelected":
                this.stockSelected = selected.value;
                break;
              case "areasSelected":
                this.areasSelected = selected.value;
                break;
              case "positionLabelslSelected":
                this.positionLabelslSelected = selected.value;
                break;
              case "positionSelected":
                this.positionSelected = selected.value;
                break;
              case "materialCategoriesSelected":
                this.materialCategoriesSelected = selected.value;
                break;
              case "materialSelected":
                this.materialSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },
  methods: {
    onSearch() {
      // 搜索
      this.options = Object.assign({}, this.options);
    },
    resetSearch() {
      this.stockSelected = null;
      this.areasSelected = null;
      this.positionLabelslSelected = null;
      this.positionSelected = null;
      this.materialCategoriesSelected = [];
      this.materialSelected = [];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getContainersFromAPI() {
      this.loading = true;
      PositionCurrents.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.position_currents = response.data.position_currents;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
    exports() {
      PositionCurrents.exports(this.options);
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getContainersFromAPI();
        sessionStorage.setItem(
          "position-currents-options",
          JSON.stringify(this.options)
        );
      },
    },
    // 仓配中心搜索
    stockSelected: {
      handler() {
        this.options.stock_id = this.stockSelected
          ? this.stockSelected.id
          : null;
        sessionStorage.setItem(
          "position-currents-stockSelected",
          JSON.stringify(this.stockSelected)
        );
      },
    },
    // 库区
    areasSelected: {
      handler() {
        this.options.stock_area_id = this.areasSelected
          ? this.areasSelected.id
          : null;
        sessionStorage.setItem(
          "position-currents-areasSelected",
          JSON.stringify(this.areasSelected)
        );
      },
    },
    // 库位标签
    positionLabelslSelected: {
      handler() {
        this.options.position_label_id = this.positionLabelslSelected
          ? this.positionLabelslSelected.id
          : null;
        sessionStorage.setItem(
          "position-currents-positionLabelslSelected",
          JSON.stringify(this.positionLabelslSelected)
        );
      },
    },
    // 库位
    positionSelected: {
      handler() {
        this.options.stock_position_id = this.positionSelected
          ? this.positionSelected.id
          : null;
        sessionStorage.setItem(
          "position-currents-positionSelected",
          JSON.stringify(this.positionSelected)
        );
      },
    },
    // 商品分类
    materialCategoriesSelected: {
      handler() {
        this.options.category_codes = this.materialCategoriesSelected
          ? this.materialCategoriesSelected.map((e) => {
              return e.code;
            })
          : "";
        sessionStorage.setItem(
          "position-currents-materialCategoriesSelected",
          JSON.stringify(this.materialCategoriesSelected)
        );
      },
    },

    // 商品
    materialSelected: {
      handler() {
        this.options.material_ids = this.materialSelected
          ? this.materialSelected.map((e) => {
              return e.id;
            })
          : [];
        sessionStorage.setItem(
          "position-currents-materialSelected",
          JSON.stringify(this.materialSelected)
        );
      },
    },
  },
};
</script>